// import {createStore} from 'redux';
// import rootReducer from '../reducers';
//
// import {routerMiddleware} from 'react-router-redux'
//
// import createHistory from 'history/createBrowserHistory'
//
// export default function configureStore() {
//     const history = createHistory();
//     const middleware = routerMiddleware(history);
//     // noinspection JSUnresolvedFunction,JSUnresolvedVariable
//     return createStore(rootReducer, middleware,
//         // 触发 redux-devtools
//         window.devToolsExtension ? window.devToolsExtension() : undefined,
//     );
// }
//

import {createStore} from 'redux';
import rootReducer from '../reducers';
import {routerMiddleware} from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import applyMiddleware from './applyMiddleware'

const history = createHistory();
const middleware = routerMiddleware(history);
const createStoreWithMiddleware = applyMiddleware(
  middleware,
  //这里可以处理多个中间件
)(createStore);

export default function configureStore(initialState) {

  const store = createStoreWithMiddleware(rootReducer, initialState,
    // 触发 redux-devtools
    window.devToolsExtension ? window.devToolsExtension() : undefined
  );
  return store;

}



// WEBPACK FOOTER //
// ./src/store/configureStore.js